import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { EditorModule } from 'primeng/editor';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { AdministradoraDetalharComponent } from './administradora-detalhar.component';
import { AdministradoraDetalharRoutingModule } from './administradora-detalhar-routing.module';
import { InputMaskModule } from 'primeng/inputmask';
import { FormsModule } from '@angular/forms';
import { TabViewModule } from 'primeng/tabview';
import { EmpresaListarModule } from '../../empresas/empresa-listar/empresa-listar.module';
import { EmpresaListarComponent } from '../../empresas/empresa-listar/empresa-listar.component';


@NgModule({
 
  imports: [
    AdministradoraDetalharRoutingModule,
    CommonModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    InputTextareaModule,
    FileUploadModule,
    RippleModule,        
    ChipModule,
    TableModule,
    EditorModule,
    HttpClientModule,        
    TooltipModule,
    DividerModule,
    SplitButtonModule,
    ConfirmDialogModule,
    InputMaskModule,
    TabViewModule,
    EmpresaListarModule
  ],
  providers: [
    ConfirmationService
  ],
  declarations: [
    AdministradoraDetalharComponent
  ]
})
export class AdministradoraDetalharModule { }
